import { useEffect, useRef } from "react";
import { useStore } from "../../stores/use_global_state";
import { getTextToImgTaskStatus } from "../../pages/api/apiTextToImage";

function useTextToImageStatus(dictionary) {
	const { state, dispatch } = useStore();
	const timeoutRef = useRef(null);

	const checkExistingId = (newResultsData) => {
		const newTextToImgResults = newResultsData.filter((newResult) => {
			if (newResult.status !== "COMPLETED") {
				return;
			}
			if (
				state.textToImgResults.some((item) => {
					return item.id === newResult.id;
				})
			) {
				return;
			}
			newResult.task_id = state.textToImgTask.id;
			return newResult;
		});
		return newTextToImgResults;
	};

	useEffect(
		() => {
			if (state.textToImgTask !== null && state.textToImgTask?.status !== "COMPLETED" && state.textToImgTask?.status !== "FAILED") {
				const checkTaskStatus = async () => {
					let { data } = await getTextToImgTaskStatus(state.textToImgTask.id);
					dispatch({
						type: "setTextToImgTask",
						task: { ...data, eta: data.queue_place * 15 },
					});
					dispatch({
						type: "setTextToImgResults",
						results: [...checkExistingId(data.results), ...state.textToImgResults],
					});

				};

				timeoutRef.current = setTimeout(() => {
					checkTaskStatus();
				}, 5000);
			}
			if (state.textToImgTask !== null && state.textToImgTask.status === "FAILED") {
				dispatch({
					type: "setVideoError",
					error_msg: `${dictionary["An error occurred while processing the photo"]}, ${dictionary["Try again"].toLowerCase()}`,
					error_code: "text",
				});
				dispatch({
					type: "setTextToImgTask",
					task: null,
				});
				dispatch({
					type: "setTextToImgResults",
					results: [],
				});
				clearTimeout(timeoutRef.current);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[state.textToImgTask]
	);

	return timeoutRef;
}

export default useTextToImageStatus;
